<div class="search-wrapper" fxLayout="row" [ngClass]="{ 'focus': focused, 'has-input': input }" fxFlex
     (vrClickOutside)="closeDropdown()">
    <mat-icon class="search-icon">search</mat-icon>
    <input type="search"
           autocomplete="off"
           spellcheck="false"
           class="search-input"
           [(ngModel)]="input"
           (focus)="openDropdown()"
           placeholder="Search..."
           #inputElem>

    <div class="search-dropdown mat-elevation-z1">
        <div class="content results" *ngIf="input" fxLayout="column">
            <div class="heading" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="icon">search</mat-icon>
                Search results for: {{ input }}
            </div>
            <div class="items">
                <div class="item" matRipple *ngFor="let item of searchResult" [routerLink]="item.route"
                     (click)="closeDropdown()">{{ item.name }}
                </div>
            </div>
        </div>

        <div class="content recents" fxLayout="row" *ngIf="!input">
            <div class="recently" fxLayout="column" fxFlex>
                <div class="heading" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="icon">restore</mat-icon>
                    Recently Visited
                </div>
                <div class="items">
                    <div class="item" matRipple *ngFor="let item of recentlyVisited" [routerLink]="item.route"
                         (click)="closeDropdown()">{{ item.name }}
                    </div>
                </div>
            </div>
            <div class="frequently" fxLayout="column" fxFlex fxFlexOffset="16px">
                <div class="heading" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="icon">youtube_searched_for</mat-icon>
                    Frequently Visited
                </div>
                <div class="items">
                    <div class="item" matRipple *ngFor="let item of frequentlyVisited" [routerLink]="item.route"
                         (click)="closeDropdown()">{{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
